// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__hbWUG","title":"index_title__noxyk","desc":"index_desc__dLvmN","descLink":"index_descLink__GwKAJ"};